var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1856",
    d: "M14,18l-1.4-1.4l3.5-3.6H4v-2h12.1l-3.5-3.5L14,6l6,6L14,18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1856",
    d: "M14,18l-1.4-1.4l3.5-3.6H4v-2h12.1l-3.5-3.5L14,6l6,6L14,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1856",
    d: "M14,18l-1.4-1.4l3.5-3.6H4v-2h12.1l-3.5-3.5L14,6l6,6L14,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.84b507e97e21d8e4d3db1c856f64603c.svg";
export { ForwardRef as ReactComponent };